/* eslint-disable @typescript-eslint/no-explicit-any */
import { Error } from '@mui/icons-material';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import { Loading } from 'common/ui/Loading';
import { TextBlock } from 'common/ui/TextBlock';
import React, { PropsWithChildren } from 'react';

type FieldWrapperProps = PropsWithChildren<{
  variant?: 'section' | 'subhead' | 'field' | 'drawer';
  dataTestId?: string;
  label?: string | React.ReactNode;
  labelError?: boolean;
  labelSx?: SxProps;
  subLabel?: string | JSX.Element;
  subLabelSx?: SxProps;
  errorMessage?: string;
  sx?: SxProps;
  isLoading?: boolean;
}>;

export const FieldWrapper = ({
  dataTestId,
  label,
  labelError,
  labelSx,
  variant = 'field',
  subLabel,
  subLabelSx,
  errorMessage,
  sx = {},
  isLoading,
  children
}: FieldWrapperProps) => {
  return (
    <Box
      data-testid={dataTestId}
      sx={{
        width: (sx as any).width ?? '100%',
        '& .MuiInputLabel-root': {
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }
      }}
    >
      <TextBlock
        variant={variant}
        title={label}
        titleSx={{
          color: labelError || errorMessage ? 'error.main' : undefined,
          fontWeight: 600,
          ...labelSx
        }}
        subtitle={subLabel}
        subtitleSx={subLabelSx}
      />
      {errorMessage && (
        <Stack direction="row" gap="5px" sx={{ mt: 0.5 }}>
          <Error
            color="error"
            sx={{
              mt: '4px',
              fontSize: '16px'
            }}
          />
          <Typography
            color="error"
            variant="body2"
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              fontWeight: 700
            }}
          >
            {errorMessage}
          </Typography>
        </Stack>
      )}
      <Box
        sx={{
          mt: label || subLabel || errorMessage ? '15px' : 0,
          ...sx
        }}
      >
        {isLoading && (
          <Loading containerSx={{ alignItems: 'flex-start' }} size={20} />
        )}
        {!isLoading && children}
      </Box>
    </Box>
  );
};
